import React                      from 'react';
import { createStyles, Textarea } from '@mantine/core';
import { FormFieldType }          from '@core/components/form/skin-active/form-field-type';
import { IconMessage }            from '@tabler/icons';


const useStyles = createStyles((
    theme: {
        colors: { [x: string]: any[] };
        colorScheme: string;
        fn: any;
        fontSizes: any;
        spacing: any;
    }) => ({

    textArea: {
        position: 'relative',

        'Textarea': {
            height: 'auto',
            paddingTop: 50,
            paddingBottom: 4,
            fontSize: 14,
        },

        '& .mantine-Textarea-icon': {
            top: -20,
            fontSize: 20,
        },

        'label': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 20 / 2,
            zIndex: 1,
        },

        '& .mantine-Textarea-description': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            zIndex: 1,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[7],
        },

        '& .mantine-Textarea-input::placeholder': {
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[7],
        },

        '& .mantine-InputWrapper-error': {
            fontSize: 12,
            paddingTop: 6,
        },

    },

}));

export const MessageField: React.FC<FormFieldType<any>> = ({
                                                               variable,
                                                               form,
                                                               defaultValue,
                                                               errorMsg,
                                                               fieldLabel,
                                                               placeholder,
                                                               description,
                                                               inputVariant,
                                                               required,
                                                               disabled
                                                           }) => {

    const { classes } = useStyles();

    return (
        <Textarea
            className={classes.textArea}
            mt="sm"
            radius="xs"
            label={fieldLabel}
            placeholder={placeholder}
            description={description}
            error={errorMsg}
            required={required}
            disabled={disabled}
            variant={inputVariant}
            defaultValue={defaultValue}
            icon={<IconMessage size={16} stroke={1}/>}
            autosize={true}
            minRows={4}
            maxRows={4}
            {...form.getInputProps(variable)}
        />
    );

};

